import { Controller } from "@hotwired/stimulus";

class PLPBannerController extends Controller {
  static targets = [
    "toggleDescription",
    "showMore",
    "showLess",
    "description",
    "fade",
  ];

  connect() {
    this.collapsedHeight = 80; // 20 * 4px (Tailwind h-20)
    this.isExpanded = false;
    this.checkOverflow();
  }

  checkOverflow() {
    const isOverflowing =
      this.descriptionTarget.scrollHeight > this.collapsedHeight;

    this.toggleDescriptionTarget.classList.toggle(
      "tw:opacity-0",
      !isOverflowing,
    );
    this.toggleDescriptionTarget.classList.toggle(
      "tw:pointer-events-none",
      !isOverflowing,
    );
    this.fadeTarget.classList.toggle("tw:opacity-0", !isOverflowing);
  }

  toggleShowMore() {
    const el = this.descriptionTarget;

    if (this.isExpanded) {
      // COLLAPSE
      el.style.height = `${el.scrollHeight}px`;
      requestAnimationFrame(() => {
        el.style.height = "";
      });
    } else {
      // EXPAND
      el.style.height = `${el.scrollHeight}px`;
      el.addEventListener(
        "transitionend",
        () => {
          el.style.height = "auto";
        },
        { once: true },
      );
    }

    this.isExpanded = !this.isExpanded;

    this.fadeTarget.classList.toggle("tw:opacity-0", this.isExpanded);

    this.showMoreTarget.classList.toggle("tw:hidden");
    this.showLessTarget.classList.toggle("tw:hidden");
  }
}

Stimulus.register("plp-banner", PLPBannerController);
